const FALLBACK_STYLE_IMAGE_SIZE = 1;

export interface StyleImageMap {
  addImage: (
    id: string,
    image: { width: number; height: number; data: Uint8Array },
  ) => void;
  hasImage: (id: string) => boolean;
}

function createTransparentStyleImage(): {
  width: number;
  height: number;
  data: Uint8Array;
} {
  return {
    width: FALLBACK_STYLE_IMAGE_SIZE,
    height: FALLBACK_STYLE_IMAGE_SIZE,
    data: new Uint8Array(FALLBACK_STYLE_IMAGE_SIZE ** 2 * 4),
  };
}

export function addMissingStyleImageFallback(
  map: StyleImageMap,
  imageId: string | undefined,
): void {
  if (!imageId || map.hasImage(imageId)) {
    return;
  }

  map.addImage(imageId, createTransparentStyleImage());
}
